exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614]{display:inline-block;font-size:0.18667rem;line-height:0.53333rem;margin-left:0.10667rem}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614]{color:#97a8be;cursor:text}", ""]);

// exports
